/**
 * Promo Code View
 */

define(function(require, exports, module) {
    'use strict';
    const Form = require('class/form.class');
    const PortletView = require('modules/portlet/portlet.view');

    module.exports = PortletView.extend({

        accessRules: {
            allow: ['user']
        },

        events: {
            'submit form': 'submitAction'
        },

        initialize: function() {
            this.options = this.model.toJSON();
        },

        render: function() {
            this.$el.html(this.tmpl('promotion-code'));
            this.form = new Form(this.$('form'), {
                validationConfig: this.model.validationConfig
            });

            return this;
        },

        /**
         * Submit form with promo code
         * @param  {Event} e
         * @return {Deferred}
         */
        submitAction: function(e) {
            e.preventDefault();

            return this.form.validate().done((data, form) => {
                var promoTag = [{
                    name: 'Portal/Custom_Promocode',
                    type: 'text',
                    value: data.promoCode,
                    expirationDate: ''
                }];

                form.showLoading();

                Playtech.API.user.setPlayerTags(promoTag)
                    .then(() =>
                        this.model.save(data)
                            .then(response => this.successSubmit(response))
                            .catch(error => this.errorSubmit(error))
                            .finally(() => form.hideLoading())
                    )
                    .catch(() => {
                        form.hideLoading();
                        this.errorSubmitTag();
                    });
            });
        },

        successSubmit: function(response) {
            var message;

            if (response.data.result === 2) {
                message = 'Try promotion code with deposit';
            } else if (response.data.result === 3) {
                message = 'No bonuses given';
            }

            if (message) {
                this.showInfo({
                    content: message
                });
            }
        },

        errorSubmit: function(response) {
            this.form.showErrorMessages({
                content: response.data.errorMessage
            });
        },

        errorSubmitTag: function() {
            this.form.showErrorMessage({
                translation: 'playtech.mobile.system.promocode.setTag.error'
            });
        }

    });
});
